<template>
  <div>
    <b-modal
      id="pendencias-monitoramento-360"
      ref="pendencias-monitoramento-360"
      :title="'Monitoramento 360 por empresa - ' + empresaNome"
      size="lg"
      no-close-on-backdrop
      scrollable
      @hidden="fecharModal"
    >
      <template v-slot:modal-footer>
        <div class="w-100 d-flex align-items-center justify-content-between">
          <p
            class="mb-0"
            style="max-width: 70%;"
          >
            <feather-icon
              icon="AlertCircleIcon"
              size="16"
              class="text-warning"
            />
            Estamos apresentando um resumo, para consultar as informações completas acesse o menu desejado!
          </p>
          <div class="d-flex align-items-center" style="gap: 10px;">
            <b-button
              variant="outline-primary"
              size="sm"
              @click="exportarExcel"
            >
              <font-awesome-icon icon="fa-solid fa-file-export" class="mr-50" />
              Exportar Excel
            </b-button>
            <b-button
              variant="primary"
              size="sm"
              @click="fecharModal"
            >
              OK
            </b-button>
          </div>
        </div>
      </template>

      <div
        v-if="carregando"
        class="d-flex justify-content-center align-items-center py-3"
      >
        <b-spinner variant="primary" />
      </div>

      <div
        v-else
        class="d-flex"
      >
        <!-- Sidebar esquerda -->
        <div style="min-width: 160px; max-width: 160px;">
          <b-list-group style="border-radius: 0 !important">
            <b-list-group-item
              v-for="aba in abas"
              :key="aba.value"
              :active="abaAtiva === aba.value"
              class="cursor-pointer"
              style="border-radius: 0 !important"
              @click="selecionarAba(aba.value)"
            >
              {{ aba.label }}
            </b-list-group-item>
          </b-list-group>
        </div>

        <!-- Área da tabela -->
        <div class="flex-grow-1 pl-1">
          <b-table
            :items="itensDaAba"
            :fields="camposDaAba"
            small
            striped
            hover
            class="mb-0"
            tbody-tr-class="cursor-pointer"
            @row-clicked="navegarParaRotina"
          >
            <template #cell(status)="{ item }">
              <span
                v-if="item.status"
                :style="{ color: item.status.toLowerCase() === 'regular' ? '#74B491' : '#EA5455', fontWeight: '600' }"
              >
                {{ item.status }}
              </span>
              <span v-else>-</span>
            </template>

            <template #cell(consultadoEm)="{ item }">
              {{ item.consultadoEm || '-' }}
            </template>

            <template #cell(validade)="{ item }">
              {{ item.validade || '-' }}
            </template>

            <template #cell(acao)="{ item }">
              <span
                v-if="temDocumentoVisualizavel(item)"
                v-b-tooltip.hover="{ placement: 'top', boundary: 'window' }"
                title="Visualizar documento"
              >
                <b-btn
                  variant="none"
                  class="btn btn-none rounded-pill m-0 icone-acao p-0 btn-none"
                  @click.stop="visualizarDocumento(item)"
                >
                  <font-awesome-icon
                    icon="fa-sharp fa-regular fa-clipboard"
                    class="text-primary"
                    style="font-size:1.3rem !important;width:22px"
                  />
                </b-btn>
              </span>
              <span v-else>-</span>
            </template>
          </b-table>
        </div>
      </div>

      <loading
        :show-cancel-button="false"
        :is-loading="isLoading"
        :descricao="descricaoLoading"
      />
    </b-modal>

    <visualizar-arquivo
      v-if="mostrarVisualizacao && urlVisualizacao"
      :url="urlVisualizacao"
      @hidden="fecharVisualizacao()"
    />
  </div>
</template>

<script>
import { BListGroup, BListGroupItem, BTable } from 'bootstrap-vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import api from '../../services/api'

export default {
  name: 'PendenciasMonitoramento360',
  components: {
    BListGroup,
    BListGroupItem,
    BTable,
    FontAwesomeIcon,
    Loading: () => import('@pilar/components/loading/Loading.vue'),
    VisualizarArquivo: () => import('@pilar/components/visualizar-arquivo/VisualizarArquivo.vue'),
  },
  props: {
    empresaId: {
      type: Number,
      required: true,
    },
    empresaNome: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      carregando: true,
      isLoading: false,
      descricaoLoading: '',
      mostrarVisualizacao: false,
      urlVisualizacao: null,
      abaAtiva: 'federal',
      pendencias: {
        federal: [],
        certidoes: [],
        parcelamentos: [],
        simplesNacional: [],
      },
      abas: [
        { value: 'federal', label: 'Federal' },
        { value: 'certidoes', label: 'Certidões' },
        { value: 'parcelamentos', label: 'Parcelamentos' },
        { value: 'simplesNacional', label: 'Simples Nacional' },
      ],
      rotasPorRotina: {
        'Situação Fiscal': 'situacaofiscal-view',
        DCTFWeb: 'dctfweb-view',
        'CND RFB/PGFN': 'cndfederal-view',
        'CND FGTS': 'cndfgts-view',
        'CND Trabalhista': 'cndtrabalhista-view',
        'CND Estadual': 'cndestadual-view',
        'CND Municipal': 'cndmunicipal-view',
        'Simples Nacional': 'dasparcelamento-view',
        'PERT-SN': 'parcelamento_pertsn-view',
        'RELP-SN': 'parcelamento_relpsn-view',
        RFB: 'parcelamento_rfb-view',
        'Não Previdenciário': 'parcelamento_nao_previdenciario-view',
        'Simplificado Previdenciário': 'parcelamento_simpl_previdenciario-view',
        PGFN: 'pgfnparcelamento-view',
        Sublimite: 'sublimite-view',
        DAS: 'das-view',
      },
    }
  },
  computed: {
    itensDaAba() {
      return this.pendencias[this.abaAtiva] || []
    },
    camposDaAba() {
      const base = [
        { key: 'rotina', label: 'ROTINA' },
        { key: 'status', label: 'STATUS' },
        { key: 'consultadoEm', label: 'CONSULTADO EM' },
        { key: 'acao', label: 'AÇÃO', class: 'text-center' },
      ]
      if (this.abaAtiva === 'certidoes') {
        base.push({ key: 'validade', label: 'VALIDADE' })
      }
      return base
    },
  },
  created() {
    api.getPendencias(this.empresaId)
      .then(payload => {
        if (payload.data) {
          this.pendencias = payload.data
        }
      })
      .finally(() => {
        this.carregando = false
        this.$nextTick(() => {
          this.$bvModal.show('pendencias-monitoramento-360')
        })
      })
  },
  methods: {
    selecionarAba(aba) {
      this.abaAtiva = aba
    },
    fecharModal(bvEvent) {
      if (bvEvent && bvEvent.target && bvEvent.target.id && bvEvent.target.id !== 'pendencias-monitoramento-360') {
        return
      }
      this.$emit('hidden')
    },
    navegarParaRotina(item) {
      const nomeDaRota = this.rotasPorRotina[item.rotina]
      if (!nomeDaRota) return
      const resolved = this.$router.resolve({ name: nomeDaRota })
      window.open(resolved.href, '_blank')
    },
    temDocumentoVisualizavel(item) {
      if (item.rotina === 'Sublimite') return false
      return !!item.consultadoEm
    },
    visualizarDocumento(item) {
      this.descricaoLoading = 'Estamos quase lá! Sua visualização está sendo preparada. Aguarde alguns instantes.'
      this.isLoading = true
      api.visualizarDocumentos(this.empresaId, [item.rotina])
        .then(payload => {
          this.urlVisualizacao = payload.data
          this.mostrarVisualizacao = true
        })
        .catch(error => {
          const mensagem = error.response?.data?.message || 'Não foi possível gerar a visualização do documento.'
          this.$erro(mensagem)
        })
        .finally(() => {
          this.isLoading = false
          this.descricaoLoading = ''
        })
    },
    fecharVisualizacao() {
      this.mostrarVisualizacao = false
      this.urlVisualizacao = null
    },
    exportarExcel() {
      this.descricaoLoading = 'Aguarde! Gerando o arquivo de pendências.'
      this.isLoading = true
      api.baixarPendenciasEmExcel(this.empresaId)
        .then(payload => {
          if (payload.data && payload.data.url) {
            window.open(payload.data.url)
            api.deletarExcel(payload.data.url, payload.data.nomeArquivo)
            this.$sucesso('Exportação realizada com sucesso!')
          } else {
            this.$erro('Não foi possível gerar o arquivo Excel.')
          }
        })
        .catch(error => {
          const mensagem = error.response?.data?.message || 'Não foi possível exportar para excel.'
          this.$erro(mensagem)
        })
        .finally(() => {
          this.isLoading = false
          this.descricaoLoading = ''
        })
    },
  },
}
</script>
